import {
  Alert as UiAlert,
  AlertDescription,
  AlertTitle,
} from "@/components/ui/alert";

/**
 * Compatibility Alert used by feature pages.
 * Supports `tone` (legacy) and `type` (settings pages); maps to shadcn variants.
 */
export function Alert({ tone, type, children, title }) {
  if (!children) {
    return null;
  }

  const kind = tone || type || "error";
  const destructive = kind === "error" || kind === "danger" || kind === "destructive";

  return (
    <UiAlert variant={destructive ? "destructive" : "default"}>
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      <AlertDescription>{children}</AlertDescription>
    </UiAlert>
  );
}
